export default {
  login (token, callback) {
    window.localStorage.setItem('token',token);
    if (callback) callback();
  },

  getToken () {
    return window.localStorage.getItem('token');
  },

  logout (cb) {
    window.localStorage.removeItem('token');
    if (cb) cb()
    location.href = '/#/login';
  },

  loggedIn () {
    return !!window.localStorage.getItem('token');
  }
}
